import { useState, useEffect } from "react";
import { isOrdersRealtimeActive } from "@/pages/orders-new/orders-realtime";

export function useRealtimeStatus() {
  const [isConnected, setIsConnected] = useState<boolean | null>(null);
  const [isChecking, setIsChecking] = useState(false);

  const checkConnection = () => {
    setIsChecking(true);
    const connected = isOrdersRealtimeActive();
    setIsConnected(connected);
    setIsChecking(false);
  };

  useEffect(() => {
    // Check immediately
    checkConnection();

    // Check every 10 seconds
    const interval = setInterval(checkConnection, 10000);

    // Listen for instant status changes
    const handleOpen = () => setIsConnected(true);
    const handleClose = () => setIsConnected(false);
    window.addEventListener("orders-realtime:open", handleOpen as any);
    window.addEventListener("orders-realtime:close", handleClose as any);

    return () => {
      clearInterval(interval);
      window.removeEventListener("orders-realtime:open", handleOpen as any);
      window.removeEventListener("orders-realtime:close", handleClose as any);
    };
  }, []);

  return {
    isConnected,
    isChecking,
    checkConnection,
  };
}

// Helper function to check if realtime is available (for backward compatibility)
export function checkRealtimeConnection() {
  return isOrdersRealtimeActive();
}
